import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const IngestService = {
    fetchIngestDate: async () => {
        try {
            const response = await ApiService.getData("/v1/system/settings", { key: "ingest_date" });

            if (response && response.key) {
                return {
                    success: true,
                    data: response
                };
            } else {
                return {
                    success: false,
                    error: "Setting not found for key: ingest_date"
                };
            }
        } catch (err) {
            Logger.error("Error fetching ingest date setting:", err);
            return {
                success: false,
                error: err.message || "Failed to fetch ingest date setting"
            };
        }
    },

    ingestArticles: async (fromDate, toDate) => {
        try {

            const response = await ApiService.putData("/v1/guardian/articles/ingest?from-date=" + fromDate + "&to-date=" + toDate);

            return {
                success: true,
                data: response
            };
        } catch (err) {
            Logger.error("Error ingesting articles:", err);
            return {
                success: false,
                error: err.message || "Failed to ingest articles"
            };
        }
    },

    fetchWikipediaDate: async () => {
        try {
            const response = await ApiService.getData("/v1/system/settings", { key: "wiki_onthisday_date" });

            if (response && response.key) {
                return {
                    success: true,
                    data: response
                };
            } else {
                return {
                    success: false,
                    error: "Setting not found for key: wiki_onthisday_date"
                };
            }
        } catch (err) {
            Logger.error("Error fetching Wikipedia ingest date setting:", err);
            return {
                success: false,
                error: err.message || "Failed to fetch Wikipedia ingest date setting"
            };
        }
    },

    fetchAllSettings: async () => {
        try {
            const response = await ApiService.getData("/v1/system/settings/all");

            if (response && response.settings && Array.isArray(response.settings)) {
                return {
                    success: true,
                    data: response
                };
            } else {
                return {
                    success: false,
                    error: "Invalid response format"
                };
            }
        } catch (err) {
            Logger.error("Error fetching all settings:", err);
            return {
                success: false,
                error: err.message || "Failed to fetch settings"
            };
        }
    },

    ingestWikipediaArticles: async (month, day) => {
        try {
            const response = await ApiService.putData(`/v1/wikipedia/articles/ingest?month=${month}&day=${day}`);

            return {
                success: true,
                data: response
            };
        } catch (err) {
            Logger.error("Error ingesting Wikipedia articles:", err);
            return {
                success: false,
                error: err.message || "Failed to ingest Wikipedia articles"
            };
        }
    },

    ingestNasaApod: async (date) => {
        try {
            const url = `/test/nasa/apod/${date}`;
            const response = await ApiService.putData(url, {});

            return {
                success: true,
                data: response
            };
        } catch (err) {
            Logger.error("Error ingesting NASA APOD:", err);
            return {
                success: false,
                error: err.message || "Failed to ingest NASA APOD"
            };
        }
    },

    processAllWikinewsArticles: async () => {
        try {
            const response = await ApiService.putData("/test/wikinews/articles", {});

            return {
                success: true,
                data: response
            };
        } catch (err) {
            Logger.error("Error processing all Wikinews articles:", err);
            return {
                success: false,
                error: err.message || "Failed to process Wikinews articles"
            };
        }
    },

    processWikinewsArticle: async (title) => {
        try {
            const encodedTitle = encodeURIComponent(title);
            const response = await ApiService.putData(`/test/wikinews/article/${encodedTitle}`, {});

            return {
                success: true,
                data: response
            };
        } catch (err) {
            Logger.error("Error processing Wikinews article:", err);
            return {
                success: false,
                error: err.message || "Failed to process Wikinews article"
            };
        }
    },

    processGoogleBook: async () => {
        try {
            const response = await ApiService.putData("/test/googlebook", {});

            return {
                success: true,
                data: response
            };
        } catch (err) {
            Logger.error("Error processing Google Book", err);
            return {
                success: false,
                error: err.message || "Failed to process Google Book"
            };
        }
    }
};

export default IngestService;

